import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import CText from "../Components/CText";
import { BsEmojiSmile } from "react-icons/bs";

const items = [
  {
    src: "https://picsum.photos/id/123/1200/400",
    role: "Full Stack Developer",
    name: "Arslan Khan",
    message: `"Abdullah is one of the best among all people I have ever met and is a loyal colleague, understands complex matters. He is a strong and goal oriented team player; with every problem there was a solution."`,
    key: 1,
  },
  {
    src: "https://picsum.photos/id/123/1200/400",
    role: "Senior AI Engineer, Python developer",
    name: "Mahad Khan",
    message: `"Abdullah is a well connected professional that always takes the time to support anyone is his network. He has a very impressive background and profile and I recommend him as a good developer to connect with."`,
    key: 1,
  },
  {
    src: "https://picsum.photos/id/678/1200/400",
    role: "UI/UX Engineer",
    name: "Ammad Ahmed",
    message: `"Abdullah is one of the most valuable people I have ever met. Both smart and professional. Experienced, deadline-oriented, and intelligent person. I confidently recommend him to any company looking for a Developer.."`,

    key: 3,
  },
  {
    src: "https://picsum.photos/id/456/1200/400",
    role: "Senior React Native Developer",
    name: "Syed Ebad",
    message: `"I have worked with Abdullah and found him an energetic, quick learner & hard working individual. He was always determined & sincere with the work assigned to him. I would definately recommend him."`,

    key: 2,
  },
];

function Example(args) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <div className="CarouselItem">
          <CText
            className="align-content-center"
            fontSize="1.5rem"
            text={item.message}
          />
          <CText className="testName" fontSize="1.4rem" text={item.name} />
          <CText fontSize="1rem" text={item.role} />
        </div>
      </CarouselItem>
    );
  });

  return (
    <div className="CarouselContainer">
      <CText
        className="CaraouselHeading"
        fontSize="2.5rem"
        text="Testimonials"
      />
      <CText
        className="CaraouselSubheading px-5"
        fontSize="1.2rem"
        text="I've been fortunate to receive heartwarming testimonials from the professionals I've partnered with..."
      />

      <Carousel
        activeIndex={activeIndex}
        next={next}
        interval={false}
        dark={true}
        previous={previous}
        {...args}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        {/* <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
        /> */}
      </Carousel>
    </div>
  );
}

export default Example;
